import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useEffect } from 'react';

const useStyle = makeStyles({
    buttonToTopVisible: {
        position: 'fixed',
        bottom: '3%',
        right: '3%',
        zIndex: 2,
        backgroundColor: '#22B7C5',
        color: 'white',
        opacity: 100,
        '&:hover, &.Mui-focusVisible': {
            transition: '0.3s',
            color: ' white',
            backgroundColor: '#002952',
        },
    },
    buttonNotVisible: {
        position: 'fixed',
        bottom: '3%',
        right: '3%',
        visibility: 'hidden',
    },
});

const BackToTop = () => {
    const [show, setShow] = useState(false);
    const classes = useStyle();

    const handleScroll = () => {
        if (window.pageYOffset > 200) {
            setShow(true);
        } else {
            setShow(false);
        }
    };

    useEffect(() => {
        window.addEventListener(`scroll`, handleScroll);
        return () => window.removeEventListener(`scroll`, handleScroll);
    }, []);

    const handleClick = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className={show ? '' : `${classes.buttonNotVisible}`}>
            <Button onClick={handleClick} className={show ? `${classes.buttonToTopVisible}` : `${classes.buttonNotVisible}`}>
                <KeyboardArrowUpIcon />
            </Button>
        </div>
    );
};

export default BackToTop;
